import { useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import { SaveFilterScreenProps } from 'home/stack/types'
import { cloneDeep } from 'lodash'
import React, { useCallback, useLayoutEffect } from 'react'
import { showHeaderButton } from 'shared/header/header_button'
import { useFiltersContext } from '../context'
import { Preset } from '../types'
import { SaveFilterView } from './view'

export function SaveFilterScreen({ route, navigation }: SaveFilterScreenProps) {
  const { theme } = useTheme()

  const {
    savedPresets,
    setSavedPresets,
    currentFilters,
    setCurrentSelectedPresetIndex,
  } = useFiltersContext()

  useLayoutEffect(
    () =>
      showHeaderButton({
        navigation,
        theme,
        title: t('cancel'),
        onPress: async () => {
          navigation.goBack()
        },
      }),
    [navigation, theme]
  )

  const onSaveFilter = useCallback(
    (selectedPreset: Preset) => {
      if (!savedPresets) {
        return
      }
      setSavedPresets(
        savedPresets.map(preset =>
          preset.id === selectedPreset.id
            ? { ...preset, filters: cloneDeep(currentFilters) }
            : preset
        )
      )
      setCurrentSelectedPresetIndex(selectedPreset.id)

      navigation.goBack()
    },
    [
      currentFilters,
      navigation,
      savedPresets,
      setCurrentSelectedPresetIndex,
      setSavedPresets,
    ]
  )

  return (
    <SaveFilterView savedPresets={savedPresets} onSaveFilter={onSaveFilter} />
  )
}
